<template>
  <div>
    <div class="loader"></div>
    <div class="top-menu" v-bind:class="{ fixed: isFixed }">
      <div class="container">
        <div class="top-menu-content">
          <div class="logo">
            <router-link
              to="/dashboard"
              v-if="
                $store.state.infoMunicipio != null &&
                $store.state.infoMunicipio.logotipo != ''
              "
            >
              <img
                :src="$store.state.infoMunicipio.logotipo"
                class="logo"
                alt="êSUS Feedback"
              />
            </router-link>
            <h3>{{ cidade }}</h3>
          </div>
          <div
            data-app
            class="input-search input-search-desktop"
            :class="[
              inputSearchActive
                ? 'input-search-active'
                : 'input-search-inactive',
            ]"
          >
            <v-autocomplete
              placeholder="Buscar"
              prepend-icon=""
              v-model="routeSelected"
              :items="routesToSearch"
              item-text="titulo"
              item-value="titulo"
              v-click-outside="onClickOutsideInputSearch"
              outlined
              ref="autocomplete"
            >
              <template v-slot:prepend>
                <v-icon @click.prevent="onClickSearch()">
                  {{ inputSearchActive ? 'mdi mdi-close' : ' mdi mdi-magnify' }}
                </v-icon>
              </template>
              <template v-slot:item="data">
                <router-link :to="data.item.link">
                  <div class="input-search-item">
                    <div class="item-search">
                      <div class="icone-paper">
                        <span class="mdi mdi-file-outline"></span>
                      </div>
                      <div>
                        <div class="item-category">
                          {{ data.item.titulo }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="description">{{ data.item.info }}</div> -->
                  </div>
                </router-link>
              </template>
            </v-autocomplete>
          </div>

          <!-- INPUT SEARCH MOBILE -->
          <div
            data-app
            class="input-search input-search-mobile input-search-active"
          >
            <v-autocomplete
              placeholder="Buscar"
              prepend-icon=""
              v-model="routeSelected"
              :items="routesToSearch"
              item-text="titulo"
              item-value="titulo"
              outlined
            >
              <template v-slot:item="data">
                <router-link :to="data.item.link">
                  <div class="input-search-item">
                    <div class="item-search">
                      <div class="icone-paper">
                        <span class="mdi mdi-file-outline"></span>
                      </div>
                      <div>
                        <div class="item-category">
                          {{ data.item.titulo }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="description">{{ data.item.info }}</div> -->
                  </div>
                </router-link>
              </template>
            </v-autocomplete>
          </div>
          <!-- INPUT SEARCH MOBILE -->

          <div class="options-user">
            <ul>
              <li>
                <router-link to="/dashboard">Início</router-link>
              </li>
              <!-- <li>
                <a href="#" v-on:click.prevent.stop=""
                  >Ajuda <i class="icofont-caret-down"></i
                ></a>
                <ul class="second-level-menu help-menu">
                  <li>
                    <a href="#" v-on:click.prevent.stop=""
                      >PEC <i class="icofont-caret-right"></i
                    ></a>
                    <ul class="third-level-menu">
                      <li v-for="(item, index) in pec">
                        <a
                          href="#"
                          v-if="item.type == 'video'"
                          v-on:click.prevent.stop="openedModalHelp(item.link)"
                        >
                          {{ item.title }}
                        </a>
                        <a
                          href="#"
                          v-if="item.type == 'slide'"
                          v-on:click.prevent.stop="openedModalSlide(item)"
                        >
                          {{ item.title }}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="#" v-on:click.prevent.stop=""
                      >CDS <i class="icofont-caret-right"></i
                    ></a>
                    <ul class="third-level-menu">
                      <li v-for="(item, index) in cds">
                        <a
                          href="#"
                          v-if="item.type == 'video'"
                          v-on:click.prevent.stop="openedModalHelp(item.link)"
                        >
                          {{ item.title }}
                        </a>
                        <a
                          href="#"
                          v-if="item.type == 'slide'"
                          v-on:click.prevent.stop="openedModalSlide(item)"
                        >
                          {{ item.title }}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li> -->
              <li>
                <a
                  href=""
                  title="Aumentar fonte"
                  v-on:click.prevent.stop="aumentarFonte()"
                  >A+</a
                >
              </li>
              <li>
                <a
                  href=""
                  title="Diminuir fonte"
                  v-on:click.prevent.stop="diminuirFonte()"
                  >A-</a
                >
              </li>
              <li>
                <a href="#" v-on:click.prevent.stop="">
                  <img
                    v-if="$store.state.fotoPerfil"
                    :src="`https://esusfeedback.com.br/api/uploads/usuarios/${$store.state.fotoPerfil}`"
                    alt="Foto de perfil"
                    class="avatar-user"
                  />
                  <i v-else class="icofont-user-alt-7"></i>
                  <h3 class="name-user">
                    {{ nomeUsuario }}
                  </h3>
                  <i class="icofont-caret-down"></i>
                </a>
                <ul class="second-level-menu user-menu">
                  <li>
                    <router-link to="/dashboard"
                      ><i class="icofont-home"></i> Início</router-link
                    >
                  </li>
                  <li v-if="id_funcao == 4 || id_funcao == 8">
                    <a href="#" v-on:click.prevent.stop="trocarAcesso()">
                      <i class="icofont-exchange"></i> Trocar acesso</a
                    >
                  </li>
                  <li>
                    <a href="#" v-on:click.prevent.stop="modalVersion = true">
                      <i class="icofont-star"></i> Novidades da versão
                    </a>
                  </li>
                  <!-- <li v-if="id_funcao == 1">
                    <router-link to="/cadastrar-admin">
                      <i class="icofont-ui-user"></i>
                      Cadastrar administrador
                    </router-link>
                  </li> -->
                  <li v-if="$store.state.cod_ibge != '1111111'">
                    <router-link to="/atualizar-cadastro" href="">
                      <i class="icofont-edit"></i> Atualizar cadastro
                    </router-link>
                  </li>
                  <li v-on:click.prevent.stop="adjust()">
                    <a href="" title="Alto contraste">
                      <i class="icofont-adjust"></i> Contraste
                    </a>
                  </li>
                  <li
                    v-if="$store.state.cod_ibge != '1111111'"
                    v-on:click.prevent.stop="modalExcluirConta = true"
                  >
                    <a href="" title="Excluir conta">
                      <i class="icofont-close"></i> Excluir conta
                    </a>
                  </li>
                  <li v-if="$store.state.demonstracao == false">
                    <a href="#" @click.prevent="abrirModalNps">
                      <i class="icofont-ui-rate-blank"></i> Avaliar este Sistema
                    </a>
                  </li>
                  <li
                    v-if="
                      $store.state.municipios &&
                      $store.state.municipios.length > 1
                    "
                  >
                    <a
                      href="#"
                      v-on:click.prevent.stop="
                        $router.push('/alterar-municipio')
                      "
                    >
                      <i class="icofont-exchange"></i> Alterar município</a
                    >
                  </li>
                  <li v-on:click.prevent.stop="logout()">
                    <a href="#"> <i class="icofont-logout"></i> Sair</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <ModalNps :show="modalNpsVisible" @close="fecharModalNps" />

      <!-- Modal excluir conta -->
      <b-modal
        id="modal-excluir-conta"
        ref="modal"
        title="Deseja realmente excluir a sua conta?"
        v-model="modalExcluirConta"
        centered
      >
        <p>
          Ao excluir a conta, o usuário perde o acesso ao sistema, entretanto
          você poderá acessá-lo novamente criando uma nova conta no momento que
          desejar.
        </p>
        <template #modal-footer="{ ok, cancel, hide }">
          <b-button
            size="sm"
            variant="danger"
            @click="modalExcluirConta = false"
          >
            Cancelar
          </b-button>
          <b-button size="sm" variant="success" @click="excluirConta()">
            Excluir
            <b-spinner
              label="Spinning"
              small
              variant="white"
              v-if="loadingBtnExcluirConta"
            ></b-spinner>
          </b-button>
        </template>
      </b-modal>

      <!-- Modal versão -->
      <novidades-da-versao v-model="modalVersion"></novidades-da-versao>

      <div class="modal-help">
        <transition name="modal" v-if="openedModal == true">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-body">
                  <slot name="body">
                    <iframe
                      width="100%"
                      height="315"
                      :src="modalHelp.link"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </slot>
                </div>
                <div class="modal-footer">
                  <slot name="footer">
                    <!-- fechar modal -->
                    <button
                      class="modal-default-button"
                      @click="openedModal = false"
                    >
                      Fechar
                    </button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- // MODAL SLIDE -->
      <b-modal id="modal-slide" ref="modalSlide" hide-footer>
        <template #modal-title>
          <h3>
            <b>{{ modalSlide.title }}</b>
          </h3>
        </template>
        <div class="d-block text-center">
          <b-carousel id="carousel-fade" :interval="0" fade indicators controls>
            <b-carousel-slide
              v-for="(item, index) in modalSlide.slides"
              :key="index"
              :img-src="`https://esusfeedback.com.br/api/static/slide/${modalSlide.path}/${item}`"
            >
            </b-carousel-slide>
          </b-carousel>
        </div>
      </b-modal>
    </div>
    <!-- <a
      v-if="exibeBtnWhatsapp"
      href="https://api.whatsapp.com/send?phone=5583996801291"
      target="_blank"
      class="btn-whatsapp"
    >
      <i class="icofont-whatsapp"></i>
    </a> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import store from '../store/store'
import NovidadesDaVersao from './NovidadesDaVersao.vue'
import ModalNps from '@/components/ModalNps.vue'
var md5 = require('js-md5')
import { jwtDecode } from 'jwt-decode'

export default {
  name: 'MenuDashboard',
  components: {
    NovidadesDaVersao,
    ModalNps,
  },
  props: {
    pec: {
      type: Array,
      default: () => {},
    },
    cds: {
      type: Array,
      default: () => {},
    },
  },
  created() {
    this.nome()
    // window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    // window.addEventListener('keydown', function(e) {
    // 	switch (e.keyCode) {
    // 		case 37:
    // 			this.$refs.modalSlide.prev()
    // 			break;
    // 		case 39:
    // 			this.$refs.modalSlide.next()
    // 			break;
    // 	}
    // });

    const municipios = [
      '3525300',
      '3513009',
      '3519071',
      '3525300',
      '3518701',
      '3522505',
      '3509007',
      '3524808',
    ]

    if (
      (this.exibeBtnWhatsapp && this.$store.state.demonstracao == false) ||
      (this.$store.state.id_funcao == '2' &&
        this.$store.state.demonstracao == false &&
        !municipios.includes(this.$store.state.cod_ibge))
    ) {
      // Plugin do bitrix24

      const pluginExists = this.isMyScriptLoaded(
        'https://cdn.bitrix24.com.br/b22433349/crm/site_button/loader_4_1lnv7k.js'
      )

      const plugin = document.createElement('script')
      plugin.setAttribute(
        'src',
        'https://cdn.bitrix24.com.br/b22433349/crm/site_button/loader_4_1lnv7k.js'
      )
      plugin.async = true
      if (!pluginExists) {
        document.head.appendChild(plugin)
      }

      // exibe o widget de chat do bitrix
      const element = window.document.getElementsByClassName(
        'b24-widget-button-wrapper'
      )
      if (element[0] != undefined) {
        element[0].classList.add('b24-widget-button-visible')
      }

      const uuid = this.$store.state.id
      const formatedName = this.$store.state.username.split(' ')
      const municipio = this.$store.state.cidade
      const funcao = this.getFuncao(this.$store.state.id_funcao)
      const name = formatedName[0]
      let lastName = ''
      if (formatedName.length > 1) {
        lastName = formatedName[1]
      }

      const accessToken = this.$store.state.accessToken
      const decoded = jwtDecode(accessToken)
      const telefone = decoded.telefone
      const email = decoded.email

      window.addEventListener('onBitrixLiveChat', function (event) {
        var widget = event.detail.widget

        const uuid_secret = '8b13e5bf-f1f3-47d5-ac3b-f8f4f35c4ac5'
        const site = location.hostname
        const id = uuid

        const hash = md5(id + site + uuid_secret)

        // Identificação da autorização externa do usuário
        widget.setUserRegisterData({
          hash: hash,
          name: name,
          lastName: lastName,
          avatar: '',
          email: '',
          www: location.hostname,
        })

        // Identificação das informações adicionais (formato alargado; publicado no início de uma nova sessão)
        widget.setCustomData([
          {
            USER: {
              NAME: `${name} ${lastName}`,
              AVATAR: '',
            },
          },
          {
            GRID: [
              {
                NAME: 'Município',
                VALUE: municipio,
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Função',
                VALUE: funcao.label,
                DISPLAY: 'LINE',
              },
              {
                NAME: 'E-mail',
                VALUE: email,
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Telefone',
                VALUE: telefone,
                DISPLAY: 'LINE',
              },
              // {
              //   NAME: 'Site',
              //   VALUE: location.hostname,
              //   DISPLAY: 'LINE',
              // },
              // {
              //   NAME: 'Página',
              //   VALUE:
              //     '[url=' +
              //     location.href +
              //     ']' +
              //     (document.title || location.href) +
              //     '[/url]',
              //   DISPLAY: 'LINE',
              // },
            ],
          },
        ])

        widget.open()

        // o widget foi fechado
        widget.subscribe({
          type: BX.LiveChatWidget.SubscriptionType.widgetClose,
          callback: function (data) {
            window.postMessage('fechar', '*')
          },
        })

        // o operador enviou uma mensagem
        // widget.subscribe({
        //   type: BX.LiveChatWidget.SubscriptionType.operatorMessage,
        //   callback: function (data) {
        //     console.log('recebeu')
        //   },
        // })
      })
    }
  },
  computed: {
    ...mapState(['cidade', 'cod_ibge', 'id_funcao']),
    exibeLogo() {
      if (this.$store.state.infoMunicipio?.exibe_logoefb == '1') {
        return true
      }
      return false
    },
    exibeBtnWhatsapp() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    routesToSearch() {
      let data = []
      const permissoes = this.$store.state.permissoes
      for (const key in permissoes) {
        // console.log(`${key}: ${permissoes[key]}`)
        for (let index = 0; index < permissoes[key].length; index++) {
          const element = permissoes[key][index]
          data.push(element)
        }
      }
      return data
    },
  },
  data() {
    return {
      nomeUsuario: '',
      dropdownBool: false,
      dropdown: '',
      openedModal: false,
      modalHelp: {
        link: '',
      },
      isFixed: false,
      modalSlide: {
        title: '',
        path: '',
        slides: [],
      },
      modalVersion: false,
      routeSelected: '',
      inputSearchActive: false,
      modalExcluirConta: false,
      loadingBtnExcluirConta: false,
      modalNpsVisible: false,
    }
  },
  methods: {
    isMyScriptLoaded(url) {
      var scripts = document.getElementsByTagName('script')
      for (var i = scripts.length; i--; ) {
        if (scripts[i].src == url) return true
      }
      return false
    },

    getFuncao(id) {
      const funcao = [
        { label: 'Administrador e-SUS PEC', value: 2 },
        { label: 'Agente Comunitário de Saúde', value: 3 },
        { label: 'Aux/Téc Enfermagem', value: 6 },
        { label: 'Gerente/Coordenador(a)', value: 7 },
        { label: 'Coordenador(a) de UBS', value: 4 },
        { label: 'Enfermeiro(a)', value: 4 },
        { label: 'Gerente', value: 1 },
        { label: 'Médico(a)', value: 4 },
        { label: 'Odontólogo(a)', value: 8 },
        { label: 'Recepcionista', value: 5 },
        { label: 'Secretário(a)', value: 1 },
      ]
      return funcao.find((el) => el.value == Number(id))
    },

    onClickSearch() {
      this.inputSearchActive = !this.inputSearchActive
      if (this.inputSearchActive) {
        this.$nextTick(() => {
          this.$refs.autocomplete.focus()
          this.$refs.autocomplete.isMenuActive = true // open item list
        })
      } else {
        this.$refs.autocomplete.isMenuActive = false
      }
    },

    onClickOutsideInputSearch() {
      this.inputSearchActive = false
      if (this.$refs.autocomplete != undefined) {
        this.$refs.autocomplete.isMenuActive = false
      }
    },

    async trocarAcesso() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (user) {
          this.$router.push(
            '/lotacoes/' + this.$store.state.cod_ibge + '/' + user.data.cpf
          )
        }
      } catch (error) {
        console.log(error)
      }
    },

    handleScroll() {
      if (window.pageYOffset >= 350) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },

    openedModalHelp(link) {
      this.openedModal = true
      this.modalHelp.link = link
    },

    openedModalSlide(item) {
      this.modalSlide.title = item.slide_title
      this.modalSlide.path = item.path
      this.modalSlide.slides = item.slides
      this.$refs['modalSlide'].show()
    },

    ...mapActions(['logout']),

    openDropdown() {
      this.dropdownBool = !this.dropdownBool
      if (this.dropdownBool == true) {
        this.dropdown = 'show'
      } else {
        this.dropdown = ''
      }
    },

    nome() {
      var arr = this.$store.state.username.split(' ')
      if (arr.length > 1) {
        var keep = arr[1][0]?.toUpperCase() != arr[1][0]
        this.nomeUsuario = arr.slice(0, keep ? 3 : 2).join(' ')
      } else {
        this.nomeUsuario = arr[0]
      }
    },

    aumentarFonte() {
      let elements = document.querySelector('body').querySelectorAll('*')
      let fonts = []

      function getFontSize() {
        for (let i = 0; i < elements.length; i++) {
          let fontSize = window
            .getComputedStyle(elements[i], null)
            .getPropertyValue('font-size')
          fonts.push(parseFloat(fontSize))
        }
      }

      getFontSize()

      for (let i = 0; i < elements.length; i++) {
        ++fonts[i]
        elements[i].style.fontSize = fonts[i] + 'px'
      }
    },

    diminuirFonte() {
      let elements = document.querySelector('body').querySelectorAll('*')
      let fonts = []

      function getFontSize() {
        for (let i = 0; i < elements.length; i++) {
          let fontSize = window
            .getComputedStyle(elements[i], null)
            .getPropertyValue('font-size')
          fonts.push(parseFloat(fontSize))
        }
      }

      getFontSize()

      for (let i = 0; i < elements.length; i++) {
        --fonts[i]
        elements[i].style.fontSize = fonts[i] + 'px'
      }
    },

    adjust() {
      let className = 'contrast'
      let el = document.querySelector('body')
      el.classList.toggle(className)
    },

    async excluirConta() {
      try {
        this.loadingBtnExcluirConta = true
        const response = await this.$api.post('/app/usuario/excluir', {
          id: this.$store.state.id,
        })
        if (response.data.error == true) {
          this.$toast.error(response.data.message, 'Error:', {
            position: 'topRight',
          })
        } else {
          this.$toast.success(response.data.message, 'Sucesso:', {
            position: 'topRight',
          })
          this.$store.dispatch('logout')
        }
      } catch (error) {
        console.log(error)
        this.$toast.error(
          'Por favor, entre em contato com o suporte.',
          'Error:',
          {
            position: 'topRight',
          }
        )
      } finally {
        this.loadingBtnExcluirConta = false
      }
    },

    abrirModalNps() {
      this.modalNpsVisible = true
    },

    fecharModalNps() {
      this.modalNpsVisible = false
    },
  },
}
</script>

<style>
.top-menu {
  border: none;
  background-color: #fff;
  box-shadow: 0 0 40px 0 rgb(82 63 105 / 0%);
  padding: 10px;
  transition: all ease-in-out 0.5s;
}

.top-menu img.logo {
  width: 80px !important;
  margin: 8px 0px;
}

.top-menu .logo {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-menu .logo h3 {
  font-size: 18px;
  padding-left: 20px;
  text-transform: uppercase;
  font-weight: 700;
}

.top-menu-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  position: relative;
}

.top-menu ul {
  float: right;
  margin: 20px auto;
}

.top-menu ul li {
  display: inline;
  margin: 0px 15px;
  vertical-align: middle;
}

.top-menu ul li a {
  color: #000;
  text-transform: uppercase;
  vertical-align: middle;
  font-size: 17px;
  font-weight: 600;
}

.top-menu ul li a i {
  color: #000;
  font-size: 20px;
}

.top-menu ul li i {
  color: #000;
  font-size: 20px;
  vertical-align: middle;
}

/* .top-menu .dropdown:hover ul.dropdown-menu{
	display: block;
} */

.top-menu .dropdown-menu {
  right: 0;
  left: auto;
  padding: 4px 0;
  font-size: 15px;
  -webkit-box-shadow: 0 2px 30px rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.08);
  border-color: #eff3f6;
}

.top-menu .dropdown-menu:before {
  content: '';
  position: absolute;
  top: -8.5px;
  right: 14px;
  border-bottom: 9px solid #fff;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
}

.top-menu ul li .dropdown-menu i {
  font-size: 17px;
  vertical-align: middle;
  margin-right: 5px;
}

.top-menu.fixed {
  position: fixed;
  width: 100%;
  z-index: 999;
  top: 0;
  transition: all ease-in-out 0.5s;
  padding: 0;
}

.top-menu.fixed img.logo {
  display: none !important;
  width: 60px !important;
}

.top-menu.fixed .logo h3 {
  font-size: 15px;
}

.top-menu.fixed ul {
  margin: 15px auto;
}

.top-menu.fixed ul li a {
  font-size: 15px;
}

.top-menu.fixed ul li a i {
  font-size: 15px;
}

.top-menu.fixed .dropdown-ajuda button {
  font-size: 15px;
}

.top-menu.fixed .name-user {
  font-size: 15px;
}

.top-menu select {
  width: 200px;
  display: inline-block;
  vertical-align: middle;
}

.name-user {
  font-size: 20px;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 10px;
  font-weight: 600;
}

.modal-help .modal-container {
  width: 900px;
}

.modal-help .modal-container iframe {
  height: 500px;
}

.options-user ul {
  list-style: none;
  padding: 0;
  margin: 12px 0;
  float: inherit;
}

.options-user ul > li {
  position: relative;
  float: left;
  height: 50px;
}

.options-user ul li:hover > ul {
  /* On hover, display the next level's menu */
  display: inline;
}

.second-level-menu {
  position: absolute;
  top: 40px;
  right: 0;
  width: 220px;
  list-style: none;
  padding: 0;
  margin: 0;
  display: none;
  padding: 4px 0;
  box-shadow: 0 2px 30px rgb(0 0 0 / 8%);
  border-color: #eff3f6;
  z-index: 999;
  background-color: #fff;
  border-radius: 0.25rem;
}

.second-level-menu:before {
  content: '';
  position: absolute;
  top: -8.5px;
  right: 0;
  border-bottom: 9px solid #fff;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
}

.second-level-menu > li {
  position: relative;
  height: 30px;
  vertical-align: middle;
  border-bottom: 1px solid #e9ecef;
  padding: 10px;
  margin: 0 !important;
  width: 100%;
  cursor: pointer;
}

.second-level-menu > li > a {
  font-size: 14px !important;
}

.second-level-menu > li > a i {
  float: right;
  vertical-align: middle;
  font-size: 14px !important;
  padding-top: 8px;
}

.second-level-menu > li:hover {
  background: #f7f7f7;
}

.third-level-menu {
  position: absolute;
  top: 0;
  left: 220px;
  width: auto;
  list-style: none;
  padding: 0;
  margin: 0;
  display: none;
  box-shadow: 0 2px 30px rgb(0 0 0 / 8%);
  border-color: #eff3f6;
  z-index: 999;
  background-color: #fff;
}

.third-level-menu > li {
  height: 30px;
  vertical-align: middle;
  border-top: 1px solid #e9ecef;
  padding: 10px;
  margin: 0 !important;
  width: 260px;
  z-index: 999;
  cursor: pointer;
}

.third-level-menu > li:hover {
  background: #f7f7f7;
}

.third-level-menu > li > a {
  font-size: 14px !important;
}

.top-menu .avatar-user {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  vertical-align: middle;
  margin-right: 6px;
}

#modal-slide header {
  background-image: none;
}

#modal-slide .modal-dialog {
  min-width: 950px;
}

#modal-slide .modal-body {
  padding: 20px 50px 60px 50px;
}

#modal-slide .carousel-indicators {
  bottom: -13%;
}

#modal-slide .carousel-indicators li {
  background-color: #0fafd7;
  height: 10px;
}

#modal-slide .carousel-control-prev {
  left: -10%;
}

#modal-slide .carousel-control-next {
  right: -10%;
}

#modal-slide .carousel-control-prev-icon {
  background-image: url('../assets/images/arrow-left-slide.svg') !important;
}

#modal-slide .carousel-control-next-icon {
  background-image: url('../assets/images/arrow-right-slide.svg') !important;
}

#modal-version ul {
  margin: 0 1.5em;
  list-style-position: outside;
  list-style-type: disc;
}

#modal-version ul li {
  margin-bottom: 6px;
  font-size: 14px;
}

@media screen and (max-width: 656px) {
  .top-menu.fixed {
    position: inherit;
  }
  .logo {
    margin: 5px;
    gap: 10px;
  }
  .top-menu img.logo {
    width: 60px !important;
  }
  .top-menu .logo h3 {
    font-size: 14px;
    text-align: center;
    padding-left: 0;
  }
  .top-menu-content {
    flex-direction: column;
    justify-content: center;
  }
  .top-menu .options-user {
    border-top: 1px solid #f2f2f2;
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top-menu ul {
    margin: 10px auto;
  }
  .top-menu ul li {
    display: inline-block;
    margin: 0px 10px;
    vertical-align: middle;
    height: auto;
  }
  .top-menu ul li a {
    font-size: 16px;
  }
  .top-menu ul li a i {
    font-size: 17px;
  }
  .top-menu .dropdown-menu {
    margin-left: -20px;
  }
  .name-user {
    display: none;
  }
  .second-level-menu.help-menu {
    left: 0;
  }
  .second-level-menu::before {
    left: 0;
    right: auto;
  }
  .second-level-menu.user-menu::before {
    left: auto;
    right: 0;
  }
  .third-level-menu {
    left: 0;
    top: 36px;
  }
  .modal-help .modal-container {
    width: 100%;
  }
  #modal-slide .modal-dialog {
    margin: 0;
    min-width: 100%;
  }

  #modal-slide .modal-body {
    padding: 30px;
  }

  #modal-slide .carousel-indicators {
    bottom: -28%;
  }

  #modal-slide .carousel-control-prev {
    left: -10%;
  }

  #modal-slide .carousel-control-next {
    right: -10%;
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .top-menu.fixed {
    position: inherit;
  }
  .logo {
    gap: 10px;
    margin: 5px;
  }
  .top-menu img.logo {
    width: 60px !important;
  }
  .top-menu .logo h3 {
    font-size: 16px;
    text-align: center;
    padding-left: 0;
  }
  .top-menu .options-user {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -10px;
  }
  .top-menu ul {
    margin: 10px auto;
  }
  .top-menu ul li {
    display: inline-block;
    margin: 0px 10px;
    vertical-align: middle;
    height: auto;
  }
  .top-menu ul li a {
    font-size: 16px;
  }
  .top-menu .dropdown-menu {
    margin-left: -20px;
  }
  .name-user {
    display: none;
  }
  #modal-slide .modal-dialog {
    margin: 0;
    min-width: 100%;
  }
  #modal-slide .modal-body {
    padding: 30px;
  }

  #modal-slide .carousel-indicators {
    bottom: -13%;
  }

  #modal-slide .carousel-control-prev {
    left: -10%;
  }

  #modal-slide .carousel-control-next {
    right: -10%;
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .top-menu.fixed {
    position: inherit;
  }
  .logo {
    gap: 10px;
    margin: 5px;
  }
  .top-menu img.logo {
    width: 60px !important;
  }
  .top-menu .logo h3 {
    font-size: 16px;
    text-align: center;
    padding-left: 0;
  }
  .top-menu .options-user {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -10px;
  }
  .top-menu ul {
    margin: 10px auto;
  }
  .top-menu ul li {
    display: inline-block;
    margin: 0px 10px;
    vertical-align: middle;
    height: auto;
  }
  .top-menu ul li a {
    font-size: 16px;
  }
  .top-menu .dropdown-menu {
    margin-left: -20px;
  }
  .name-user {
    display: none;
  }
  #modal-slide .modal-dialog {
    margin: 0;
    min-width: 100%;
  }
  #modal-slide .modal-body {
    padding: 30px;
  }

  #modal-slide .carousel-indicators {
    bottom: -11%;
  }

  #modal-slide .carousel-control-prev {
    left: -10%;
  }

  #modal-slide .carousel-control-next {
    right: -10%;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}

.btn-whatsapp {
  position: fixed;
  z-index: 5;
  bottom: 30px;
  right: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 20px 10px 10px;
  border-radius: 50px;
  z-index: 1000;
  text-decoration: none;
}

.btn-whatsapp:before {
  position: absolute;
  content: '';
  left: 0;
  top: 0;
  width: 60px;
  height: 60px;
  background: #89bd49;
  opacity: 0.2;
  /* animation: pulse-border 1500ms ease infinite; */
  z-index: -3;
  border-radius: 50%;
  top: 50%;
  left: 44%;
  transform: translate(-50%, -50%);
}

.btn-whatsapp i {
  background-color: green;
  width: 40px;
  height: 40px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 50%;
  position: relative;
  z-index: 2;
  text-align: center;
  color: #fff;
  font-size: 20px;
}

@keyframes pulse-border {
  0% {
    -webkit-transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(-50%) translateY(-50%) translateZ(0)
      scale(1.5);
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
    opacity: 0;
  }
}

@media screen and (max-width: 656px) {
  .btn-whatsapp {
    right: 10px;
  }
}
</style>

<style lang="scss">
.input-search {
  flex: 1;
  margin-top: -5px;
  .v-text-field {
    padding-top: 0;
  }
  .input-search-item {
    .item-search {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 14px;
      .icone-paper {
        span {
          color: #000;
        }
      }
      .item-category {
        color: #000;
      }
    }
  }
  &.input-search-active {
    background: #fff;
    padding: 10px;
    z-index: 999;
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-61%, -50%);
    @media screen and (max-width: 656px) {
      width: 100%;
      left: 50%;
      top: 60%;
      transform: translate(-50%, -10%);
    }
    @media screen and (min-width: 657px) and (max-width: 807px) {
      width: 100%;
      left: 50%;
      top: 65%;
      transform: translate(-50%, -50%);
    }

    @media screen and (min-width: 808px) and (max-width: 1023px) {
      width: 100%;
      left: 50%;
      top: 65%;
      transform: translate(-50%, -50%);
    }

    @media screen and (min-width: 1024px) and (max-width: 1265px) {
      width: calc(930px - 280px);
      transform: translate(-59%, -50%);
    }
    @media screen and (min-width: 1265px) {
      width: calc(1110px - 280px);
      transform: translate(-57%, -50%);
    }
    .v-select__slot {
      display: flex;
    }
    .v-text-field__details {
      display: none;
    }

    &.input-search-desktop {
      display: block;
      @media screen and (max-width: 656px) {
        display: none;
      }
    }

    &.input-search-mobile {
      display: none;
      @media screen and (max-width: 656px) {
        display: block;
        position: relative;
        transform: translate(-50%, 0%);
      }
    }
  }
  &.input-search-inactive {
    width: 20px;
    .v-select__slot {
      display: none;
    }
    .v-input__control {
      display: none;
    }
    .v-text-field {
      float: right;
    }
    .v-input__prepend-outer {
      margin-top: 0;
      .v-icon {
        color: #000;
      }
      @media screen and (max-width: 656px) {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.b24-widget-button-pulse-animate {
  animation: none !important;
}

#modal-excluir-conta {
  .modal-footer {
    justify-content: flex-end !important;
    .btn-danger {
      background: red;
    }
    .btn-success {
      background: green;
    }
  }
}
</style>
